import { createFileRoute } from "@tanstack/react-router";
import { TransmissoesPage } from "@/pages/TransmissoesPage";

export const Route = createFileRoute("/transmissoes/")({
  head: () => ({ meta: [{ title: "Transmissões — AXIS Comprovantes" }] }),
  component: () => <TransmissoesPage />,
});
